import { EmailViewModel, CreatePersonEmailCommand, UpdatePersonEmailCommand } from '../../models/Entities/Person/Email/EmailModels';
import { ErrorType } from '../../models/HttpError';

export const PERSON_EMAIL_GETALL_REQUEST = 'PERSON_EMAIL_GETALL_REQUEST';
export const PERSON_EMAIL_GETALL_SUCCESS = 'PERSON_EMAIL_GETALL_SUCCESS';
export const PERSON_EMAIL_GETALL_FAILURE = 'PERSON_EMAIL_GETALL_FAILURE';

export interface PersonEmailGetAllRequestAction {
    type: typeof PERSON_EMAIL_GETALL_REQUEST;
    personId: number;
}

export interface PersonEmailGetAllSuccessAction {
    type: typeof PERSON_EMAIL_GETALL_SUCCESS;
    personId: number;
    payload: EmailViewModel[];
}

export interface PersonEmailGetAllFailureAction {
    type: typeof PERSON_EMAIL_GETALL_FAILURE;
    error: ErrorType;
}

export const PERSON_EMAIL_GETBYID_REQUEST = 'PERSON_EMAIL_GETBYID_REQUEST';
export const PERSON_EMAIL_GETBYID_SUCCESS = 'PERSON_EMAIL_GETBYID_SUCCESS';
export const PERSON_EMAIL_GETBYID_FAILURE = 'PERSON_EMAIL_GETBYID_FAILURE';

export interface PersonEmailGetByIdRequestAction {
    type: typeof PERSON_EMAIL_GETBYID_REQUEST;
    id: number;
}

export interface PersonEmailGetByIdSuccessAction {
    type: typeof PERSON_EMAIL_GETBYID_SUCCESS;
    payload: EmailViewModel;
}

export interface PersonEmailGetByIdFailureAction {
    type: typeof PERSON_EMAIL_GETBYID_FAILURE;
    error: ErrorType;
}

export const PERSON_EMAIL_CREATE_REQUEST = 'PERSON_EMAIL_CREATE_REQUEST';
export const PERSON_EMAIL_CREATE_SUCCESS = 'PERSON_EMAIL_CREATE_SUCCESS';
export const PERSON_EMAIL_CREATE_FAILURE = 'PERSON_EMAIL_CREATE_FAILURE';

export interface PersonEmailCreateRequestAction {
    type: typeof PERSON_EMAIL_CREATE_REQUEST;
    payload: CreatePersonEmailCommand;
}

export interface PersonEmailCreateSuccessAction {
    type: typeof PERSON_EMAIL_CREATE_SUCCESS;
    payload: EmailViewModel;
}

export interface PersonEmailCreateFailureAction {
    type: typeof PERSON_EMAIL_CREATE_FAILURE;
    error: ErrorType;
}

export const PERSON_EMAIL_UPDATE_REQUEST = 'PERSON_EMAIL_UPDATE_REQUEST';
export const PERSON_EMAIL_UPDATE_SUCCESS = 'PERSON_EMAIL_UPDATE_SUCCESS';
export const PERSON_EMAIL_UPDATE_FAILURE = 'PERSON_EMAIL_UPDATE_FAILURE';

export interface PersonEmailUpdateRequestAction {
    type: typeof PERSON_EMAIL_UPDATE_REQUEST;
    payload: UpdatePersonEmailCommand;
}

export interface PersonEmailUpdateSuccessAction {
    type: typeof PERSON_EMAIL_UPDATE_SUCCESS;
    payload: EmailViewModel;
}

export interface PersonEmailUpdateFailureAction {
    type: typeof PERSON_EMAIL_UPDATE_FAILURE;
    id: number;
    error: ErrorType;
}

export const PERSON_EMAIL_DELETE_REQUEST = 'PERSON_EMAIL_DELETE_REQUEST';
export const PERSON_EMAIL_DELETE_SUCCESS = 'PERSON_EMAIL_DELETE_SUCCESS';
export const PERSON_EMAIL_DELETE_FAILURE = 'PERSON_EMAIL_DELETE_FAILURE';

export interface PersonEmailDeleteRequestAction {
    type: typeof PERSON_EMAIL_DELETE_REQUEST;
    id: number;
}

export interface PersonEmailDeleteSuccessAction {
    type: typeof PERSON_EMAIL_DELETE_SUCCESS;
    id: number;
}

export interface PersonEmailDeleteFailureAction {
    type: typeof PERSON_EMAIL_DELETE_FAILURE;
    id: number;
    error: ErrorType;
}
